import { useMemo } from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import GenericKPIs from './GenericKPIs'

const GenericDashboardIframe = (props) => {
  const { t_ } = useSmartTranslation()
  const { url, width = '100%', height = window.innerHeight, kioskMode = true, defaultDashboardUrl } = props

  const iframeIndicator = 'iframe:'

  const { iframeMode, urlParam } = useMemo(() => {
    if (!url) {
      return { iframeMode: false, urlParam: defaultDashboardUrl }
    }
    if (url.startsWith(iframeIndicator)) {
      return { iframeMode: true, urlParam: url.substring(iframeIndicator.length) }
    }
    return { iframeMode: false, urlParam: url }
  }, [url, defaultDashboardUrl])

  if (iframeMode) {
    return (
      <iframe
        style={{ border: 'none' }}
        title={t_('MIC-DASHBOARD')}
        src={urlParam}
        height={height}
        width={width}
      />
    )
  }
  return <GenericKPIs dashboardsUrl={url} width={width} height={height} kioskMode={kioskMode} />
}

export default GenericDashboardIframe
